// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"88e80ef2","178":"ada8a216","442":"8dceb29f"}[chunkId] + ".chunk.css";
};